<app-topbar></app-topbar>
<div class="container mr-top-40">
    <h1 class="mainhdng mr-bttm-30">Sub Admin Users</h1>
    <div class="add_new_store float-right w-100 text-right mb-3"  data-toggle="modal" data-target="#editAdminUser" (click) ="addAdmin()">
      <img src="assets/images/addstore.png" class="pd-rt-10"> <span class="rmbrme adau"> Add Sub Admin</span>
    </div>
</div>

<div class="container cntremptyscrn">
    <div class="row h-80 justify-content-center align-items-center">
        <div class="table-responsive">
            <!-- {{userList | json}} -->
            <table *ngIf = "userList?.length > 0" class="table border cstm_tble_cs NewTblBrdr">
            <thead>
            <tr class="active">
                <th style="width:40%">Full Name</th>
                <th style="width:40%">Email</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor ="let user of userList">
               
                <td><p class="boxpara">{{user.first_name}} {{user.last_name}}</p></td>
                <td><p class="boxpara">{{user.email}}</p></td>
                <td><a href="javascript:void(0)" data-toggle="modal" data-target="#editAdminUser" (click) = "openModal(user.id,user.first_name,user.last_name,user.email,user.id)"><i class="fa fa-pencil" aria-hidden="true"></i></a></td>
            </tr>
            </tbody>
            </table>
         </div>
    </div>
</div>


<!-- Change Email Modal -->
<div class="modal fade in centerModalNew" id="editAdminUser" >
    <div class="modal-dialog chngnmbrpopup">
       <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body changenumberbody" id="editAdmin">
             <div class="common billingform changenumber pt26">
                <form [formGroup]="admin_user_form" (ngSubmit)="admin_user_submit()" id="admin_user_frm">
                   <h6 class="sucssheading clrgry text-left text-dark mb-sm-5 mb-3">{{userFormTitle}}</h6>
                   <div class="form-group mb-4">
                    <input type="text" name="" ngClass="form-control" placeholder="Enter First Name" id="enterFName" formControlName="firstname" (keyup) ="clearError()">
                    <!-- <span class="inputValidation">{{ first_nameError }}</span> -->
                    <div *ngIf="adminFormSubmitted && admin_user_f.firstname.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f.firstname.errors.required">First Name is required.</span>
                        <span class="inputValidation" *ngIf="admin_user_f.firstname.errors.minlength">First Name should be 3 character.</span>
                    </div>
                 </div>
                 <div class="form-group mb-4">
                    <input type="text" name="" ngClass="form-control" placeholder="Enter Last Name" id="enterLName" formControlName="lastname" (keyup) ="clearError()">
                    <div *ngIf="adminFormSubmitted && admin_user_f.lastname.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f.lastname.errors.required">Last Name is required.</span>
                    </div>
                 </div>
                   <div class="form-group mb-4">
                      <input type="email" name="" ngClass="form-control" placeholder="Enter Email" id="enterEmail" formControlName="email" (keyup) ="clearError()">
                      <div *ngIf="adminFormSubmitted && admin_user_f.email.invalid">
                        <span class="inputValidation" *ngIf="admin_user_f.email.errors.required">Email is required.</span>
                        <span class="inputValidation" *ngIf="admin_user_f.email.errors.email">Email is not valid.</span>
                        
                    </div>
                    <span class="inputValidation">{{emailError}}</span>
                   </div>

                   <label class="sucssheading text-left mb-3 permstyle">Permissions</label>
                   <div class="container p-0 mb-5">
                     <div class="row form-group">
                       <div class="col-md-6 col-12">
                          <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission1"  value="checkout" (change)="onChange($event.target.checked, $event.target.value,'Buy Subscriptions')" formGroupName="permissions" [attr.checked] ="checkPermission('checkout')" >
                        <label class="form-check-label optstyle" for="permission1">
                           Buy Subscriptions
                        </label>
                     </div>
                       </div>
                       <div class="col-md-6 col-12">
                         <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission2"  value="company-store" (change)="onChange($event.target.checked, $event.target.value,'Companies & Stores')" formGroupName="permissions" [attr.checked] ="checkPermission('company-store')">
                        <label class="form-check-label" for="permission2">
                           Companies & Stores
                        </label>
                     </div>
                       </div>
                       <div class="col-md-6 col-12">
                         <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission3"  value="subscriptions" (change)="onChange($event.target.checked, $event.target.value,'Products & Subscriptions')" [attr.checked] ="checkPermission('subscriptions')">
                        <label class="form-check-label" for="permission3">
                           Products & Subscriptions
                        </label>
                     </div>
                       </div>
                       <div class="col-md-6 col-12">
                         <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission4"  value="users" (change)="onChange($event.target.checked, $event.target.value,'App Users')" [attr.checked] ="checkPermission('users')">
                        <label class="form-check-label" for="permission4">
                           App Users
                        </label>
                     </div>
                       </div>
                       <div class="col-md-6 col-12">
                         <div class="form-check mb-1">
                        <input class="form-check-input" type="checkbox" value="" id="permission4"  value="users" (change)="onChange($event.target.checked, $event.target.value,'App Users')" [attr.checked] ="checkPermission('users')">
                        <label class="form-check-label" for="permission4">
                           App Users
                        </label>
                     </div>
                       </div>
                     </div>
                   </div>


                     
                  

                   <div class="common changenumberbttn text-sm-left mt-sm-3 mt-0 text-center">
                      <button class="savebttn savebtn2">{{userFormBtn}}</button>
                      <button class="cancelbttn cancelbttn_email mt-sm-0" data-dismiss="modal">Close</button>
                   </div>
                   
                   <div class="common text-success sccsmsgdiv" >{{emailUpdate}}</div>
                </form>
             </div>
          </div>
       </div>
    </div>
 </div>